export const environment = {
  production: true,
  name: 'carpi_test',
  version: '0.1.00000.000'
};
